import { Paper, Stack, Typography } from '@mui/material';
import { ACCOUNT_CONTACT_DETAILS_PHRASES } from '@/consts/phrases/accountPhrases';
import { usePhrase } from '@/hooks';
import { ReactNode } from 'react';

import { Icon } from '@/components/general/Icon/Icon';

import styles from './contactDetailsBox.module.css';
interface ContactDetailBoxProps {
    type: 'email' | 'phone';
    children?: ReactNode;
}

export const ContactDetailsBox = ({ type, children }: ContactDetailBoxProps) => {
    const { t } = usePhrase();
    return (
        <Paper elevation={1} sx={{ p: 3, mb: type === 'email' ? 3 : 0 }}>
            <Stack
                direction="row"
                spacing={1}
                className={styles.block}
                sx={{ mb: type === 'email' ? 4 : 0 }}
            >
                <div>
                    {type === 'email' ? (
                        <Icon path="accountIcons/EmailIcon" />
                    ) : (
                        <Icon path="accountIcons/PhoneIcon" />
                    )}
                </div>
                <div className={styles.textContainer}>
                    <Typography variant="h5" className={styles.header}>
                        {type === 'email'
                            ? t(ACCOUNT_CONTACT_DETAILS_PHRASES.EMAIL_ADDRESS)
                            : t(ACCOUNT_CONTACT_DETAILS_PHRASES.PHONE_NUMBERS)}
                        {type === 'email' && (
                            <span className={styles.subHeader}>
                                {t(ACCOUNT_CONTACT_DETAILS_PHRASES.USED_FOR_LOGIN)}
                            </span>
                        )}
                    </Typography>
                </div>
            </Stack>
            {children}
        </Paper>
    );
};
